import React from 'react';
import styles from '../../styles/GeneracionCargosManualesStyles/GeneracionCargosManuales.module.css';
import estudiantesStyles from '../../styles/EstudiantesStyles/Estudiantes.module.css';
import programasStyles from '../../styles/PantallaDeProgramasAcademicos.v2.module.css';

function SearchSection({ searchTerm, onSearchChange, onSearch, loading }) {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !loading) {
      onSearch();
    }
  };

  return (
    <div className={estudiantesStyles.searchSection}>
      <div className={estudiantesStyles.searchCard}>
        <div className={programasStyles.programsSearchRow}>
          <div className={estudiantesStyles.searchInputGroup}>
            <svg
              className={estudiantesStyles.searchIcon}
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                stroke="#898d8d"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <input
              type="text"
              className={estudiantesStyles.searchInput}
              placeholder="Buscar Estudiante por Matrícula o Nombre"
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={loading}
            />
          </div>
          <button
            className={programasStyles.buscarButtonProgramas}
            onClick={onSearch}
            disabled={loading}
          >
            {loading ? 'BUSCANDO...' : 'BUSCAR'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SearchSection;
